module.exports = __webpack_public_path__ + "static/img/default_head.abb945e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_head.png
// module id = iBUa
// module chunks = 1